var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"delete-connection-btn",attrs:{"size":"sm","type":"is-danger","icon-right":"close"},on:{"click":function($event){$event.stopPropagation();return _vm.handleDelete()}}})}
var staticRenderFns = []

export { render, staticRenderFns }